module.exports = __webpack_public_path__ + "img/Screen_Shot_4.e599fb1f.png";